import { Box, Button, Image, breakpoints } from '@gassan-ui'
import { getKontentImage } from '@lib/kontent'
import { FC } from 'react'
import styled from 'styled-components'
import { MarginBottomProps, MarginTopProps } from 'styled-system'

const Container = styled(Box)`
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  max-width: 109rem;
  @media screen and (min-width: ${breakpoints.medium}) {
    width: calc(100% - 3rem);
  }
  @media screen and (min-width: ${breakpoints.xlarge}) {
    width: calc(100% - 5.5rem);
  }
`

const ImageContainer = styled.div`
  z-index: -1;
  &::before {
    padding-top: 70%;
    content: '';
    display: block;
    width: 100%;

    @media screen and (min-width: ${breakpoints.medium}) {
      padding-top: 70%;
    }
    @media screen and (min-width: ${breakpoints.large}) {
      padding-top: 25%;
    }

    @media screen and (max-width: ${breakpoints.medium}) and (orientation: landscape) {
      overflow: hidden;
      padding-top: 40%;
    }
  }

  > div {
    position: absolute;
  }
`

type Props = MarginTopProps &
  MarginBottomProps & {
    buttonText: string
    buttonHref: string
    mobileSrc: string
    desktopSrc: string
    alt: string
  }

const CtaBanner: FC<Props> = ({ buttonText, buttonHref, mobileSrc, desktopSrc, alt, ...rest }) => {
  const sources = [
    getKontentImage(mobileSrc, { width: 640 }),
    getKontentImage(mobileSrc, { width: 768 }),
    getKontentImage(desktopSrc, { width: 1024 }),
    getKontentImage(desktopSrc, { width: 1344 }),
    getKontentImage(desktopSrc, { width: 1444 }),
    getKontentImage(desktopSrc, { width: 1635 }),
  ]

  return (
    <Container width={['100%', 'inherit']} position="relative" {...rest}>
      <ImageContainer>
        <Image
          sources={sources}
          className="absolute inset-0"
          placeholderSrc={getKontentImage(mobileSrc, { width: 50 })}
          alt={alt}
        />
      </ImageContainer>
      {buttonHref && buttonText && (
        <Box
          position="absolute"
          bottom={[4, '3.25rem', '3.25rem', '2rem', '3.75rem']}
          width={['calc(100% - 3rem)']}
          left={0}
          right={0}
          m="0 auto"
          zIndex={2}
          display="flex"
          justifyContent="center"
        >
          <Button className="min-w-full sm:min-w-[inherit]" as="link" href={buttonHref}>
            {buttonText}
          </Button>
        </Box>
      )}
    </Container>
  )
}

export default CtaBanner
